<template>
  <div>
    <h6 class="sa-mb20 sa-mt20">Appointment Details</h6>
    <div class="sa-row sa-mt20" v-if="productData">
      <div class="sa-col-xs12 sa-col-sm12 sa-col-md6 sa-col-lg6">
        <div v-if="productData.Basic" class="sa-card sa-card-border sa-card-noshadow sa-d-f-sbetween">
          <span>
            <i class="icon-video-cons sa-blue-text sa-mr10"></i> Basic
            consultation</span
          ><strong>{{productData.Basic.count ? productData.Basic.count : 0}}/SAR {{productData.Basic.Revenue ? productData.Basic.Revenue : 0}}</strong>
        </div>
      </div>
      <div class="sa-col-xs12 sa-col-sm12 sa-col-md6 sa-col-lg6">
        <div v-if="productData.FollowUp" class="sa-card sa-card-border sa-card-noshadow sa-d-f-sbetween">
          <span>
            <i class="icon-video-cons sa-blue-text sa-mr10"></i>
            Follow up consultation</span
          ><strong>{{productData.FollowUp.count ? productData.FollowUp.count : 0}}/SAR {{productData.FollowUp.Revenue ? productData.FollowUp.Revenue : 0}}</strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['productData'],
};
</script>
